"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemNameParts = itemNameParts;
exports.formatItemName = formatItemName;
const productTypes_1 = require("./productTypes");
function itemNameParts(i) {
    const title = (i.productName || '').trim();
    const variant = (i.variantName || '').trim();
    if (i.productTypeId === productTypes_1.PRODUCT_TYPE_IDS.SINGLE_ITEM) {
        return { title: title || variant, detail: null, color: null, size: null };
    }
    if (i.productTypeId === productTypes_1.PRODUCT_TYPE_IDS.APPAREL) {
        let color = i.options?.[productTypes_1.APPAREL_AXIS.COLOR] ?? null;
        let size = i.options?.[productTypes_1.APPAREL_AXIS.SIZE] ?? null;
        // Legacy / imported rows without options: displayName is "Color / Size".
        if (!color && !size && variant.includes(' / ')) {
            const [c, s] = variant.split(' / ');
            color = c || null;
            size = s || null;
        }
        const detail = color || size ? [color, size].filter(Boolean).join(' / ') : (variant || null);
        return { title: title || variant, detail: title ? detail : null, color, size };
    }
    if (!title)
        return { title: variant, detail: null, color: null, size: null };
    if (!variant || variant === title)
        return { title, detail: null, color: null, size: null };
    if (variant.startsWith(title))
        return { title: variant, detail: null, color: null, size: null };
    return { title, detail: variant, color: null, size: null };
}
function formatItemName(i, sep = ' - ') {
    const p = itemNameParts(i);
    return p.detail ? `${p.title}${sep}${p.detail}` : p.title;
}
//# sourceMappingURL=itemName.js.map